export default __webpack_public_path__ + "static/Haris_Ali-9f619852142b32a43a5fbcf48a719b59.png";